import i18n from "i18next";
import Backend from "i18next-xhr-backend";
import { initReactI18next } from "react-i18next";
import LocalStorageBackend from "i18next-localstorage-backend";
import XHR from "i18next-xhr-backend";
import globalDE from "./translation/de/global.json";
import globalEN from "./translation/en/global.json";
import errorPageDE from "../../module/errorPage/translation/de/ErrorPageDE.json";
import errorPageEN from "../../module/errorPage/translation/en/ErrorPageEN.json";
import LanguageDetector from "i18next-browser-languagedetector";

const supportedLanguages = ["de", "en"];

const resources = {
  de: {
    translation: globalDE,
    errorpage: errorPageDE
  },
  en: {
    translation: globalEN,
    errorpage: errorPageEN
  }
};

i18n
  // lazy loading load ltranslation
  .use(Backend)
  // .use(XHR)
  // detect user language
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next
  .use(initReactI18next)
  // init i18next
  .init({
    whitelist: supportedLanguages,
    fallbackLng: "de",
    debug: false, // debug testing
    backend: [
      LocalStorageBackend, // primary
      XHR // fallback
    ],
    resources,

    interpolation: {
      /*
      format: function(value, format, lng) {
        if (format === 'bold') return value.toUpperCase();
        //if(value instanceof Date) return moment(value).format(format);
        return '<i>'+ value+ '</i>';
      },
      */
      useRawValueToEscape: false,
      escapeValue: false // react already safes from xss
    },
    /*
    detection: {
      order: ["path", "navigator"]
    },
    */
    react: {
      bindI18n: "languageChanged"
    }
  });

export default i18n;
